import {
  type FC
} from 'react';
import {
  GlobalStyles
} from '@mui/joy';

// TODO: move colors to theme
export const OverriddenCookieConsentStyles: FC = () => (
  <GlobalStyles
    styles={({ breakpoints }) => ({
      '.cookie-consent-container': {
        gap: '16px !important',
        display: 'flex !important',
        alignItems: 'center !important',
        flexDirection: 'row !important',
        padding: 16,
        minHeight: 80,
        borderWidth: 1,
        borderRadius: 8,
        backgroundColor: '#1B222D !important',
        bottom: '60px !important',
        maxWidth: '914px !important',
        left: '50% !important',
        transform: 'translateX(-50%) !important',
        right: 'auto !important',
        width: 'calc(100% - 32px) !important',
        margin: '0 auto !important',
        [breakpoints.down(768)]: {
          flexDirection: 'column !important',
        }
      },
      '.cookie-consent-content': {
        flex: '1 !important',
        margin: '0 auto !important',
      },
      '.cookie-consent-button-wrapper': {
        display: 'flex !important',
        justifyContent: 'flex-end !important',
        gap: '16px !important',
      },
      '.cookie-consent-button': {
        background: '#2F3641 !important',
        width: '108px !important',
        height: '36px !important',
        borderRadius: '8px !important',
        paddingTop: '4px !important',
        paddingRight: '16px !important',
        paddingBottom: '4px !important',
        paddingLeft: '16px !important',
        borderWidth: '1px !important',
        color: '#FFFFFF !important',
        margin: '0 !important',
      },
      '.cookie-consent-decline-button': {
        background: '#2F3641 !important',
        width: '108px !important',
        height: '36px !important',
        borderRadius: '8px !important',
        paddingTop: '4px !important',
        paddingRight: '16px !important',
        paddingBottom: '4px !important',
        paddingLeft: '16px !important',
        borderWidth: '1px !important',
        color: '#FFFFFF !important',
        margin: '0 !important',
      },
    })}
  />
);